import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'

import { useRoleCheck } from '../../features/account/hooks/roleHooks'
import { RoleEnum } from '../../features/account/types/RoleEnum'
import { UAInsightsDashboard } from '../../features/ua-insights'
import { useDocumentTitle } from '../../hooks/useDocumentTitle'
import usePage from '../../hooks/usePage'
import PageService from '../../services/PageService'

const UAInsightsPage: FC = () => {
  const { t } = useTranslation()
  usePage(PageService.getPageWithId('ua-insights'), 'Visited UA Insights')
  useDocumentTitle(t('ua-insights:page_title'))
  const hasAccess = useRoleCheck(RoleEnum.ua_insights)

  if (!hasAccess) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6">{t('ua-insights:no_access')}</Typography>
      </Box>
    )
  }

  return <UAInsightsDashboard />
}

export default UAInsightsPage
